// Deep links into the customer view sheet. One definition for the sheet's
// Tabs id and the derived URL param (`${id}-tab`, tabs.utils) — every
// surface that links "into a customer, on a specific tab" builds the href
// here instead of re-spelling the literal.

export const CUSTOMER_VIEW_TABS_ID = "customer-view-tabs"
export const CUSTOMER_VIEW_TAB_PARAM = `${CUSTOMER_VIEW_TABS_ID}-tab`

/** Tab values as declared by CustomerViewSheet's Tabs.Triggers. */
export type CustomerViewTab =
  | "tenants"
  | "users"
  | "billing"
  | "feature-access"
  | "sign-ins"

/**
 * Partial href (utils.ts partial-URL syntax) opening a customer's view
 * sheet, optionally landed on a specific tab.
 */
export function buildCustomerViewLink(
  externalCustomerId: string,
  tab?: CustomerViewTab,
) {
  const base = `?v=customer:${externalCustomerId}`
  return tab ? `${base}&${CUSTOMER_VIEW_TAB_PARAM}=${tab}` : base
}

/**
 * The Activity tab's own sub-tabs (one overview, then one per product),
 * their Tabs id and URL param. The product tabs are the usage report at
 * the customer's scope; a Portfolio row links straight to the product it
 * is about.
 */
export const CUSTOMER_ACTIVITY_TABS_ID = "customer-activity"
export const CUSTOMER_ACTIVITY_TAB_PARAM = `${CUSTOMER_ACTIVITY_TABS_ID}-tab`

export type UsageActivityTab =
  | "overview"
  | "fusion"
  | "placepoint-mcp"
  | "dataset-mcp"

/** Opens a customer's Activity tab landed on one of its sub-tabs. */
export function buildCustomerActivityTabLink(
  externalCustomerId: string,
  activityTab: UsageActivityTab,
) {
  return `${buildCustomerViewLink(externalCustomerId, "sign-ins")}&${CUSTOMER_ACTIVITY_TAB_PARAM}=${activityTab}`
}
